import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-validation-errors',
  templateUrl: './validation-errors.component.html',
  styleUrl: './validation-errors.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ValidationErrorsComponent implements OnInit {
  @Input({ required: true })
  fc!: FormControl;

  @Input()
  errors: ValidationErrors = {};

  private defaultErrors: ValidationErrors = {
    // required: 'Please fill this field with the required information',
    // min: 'The field value should be at least 0.01',
    // pattern: 'The field value is invalid',
  };

  protected validationErrors: ValidationErrors = {};

  ngOnInit(): void {
    this.validationErrors = { ...this.defaultErrors, ...this.errors };
  }

  get fcErrors(): string[] | null {
    return this.fc.touched && this.fc.errors
      ? [
          (Array.isArray(this.fc.errors)
            ? this.fc.errors
            : Object.keys(this.fc.errors))[0],
        ]
      : null;
  }
}
